import { useState, useEffect, useRef } from "react";
import api from "../services/api";
import { useToast } from "../context/ToastContext";
import { useForm } from "react-hook-form";
import { SCDropdown, SCFieldset, SCButton, SCInputText, SCInputTextarea, SCDialog, } from "../components";
import { useAuth } from "../providers/auth";
import AlunoSituacaoForm from "./AlunoSituacaoForm";
import util from '../utilities/util';
import ConfiguracaoFormulasForm from "./ConfiguracaoFormulasForm";

const ConfiguracoesFormulas = () => {
    const toast = useToast();
    const tarefa = "ConfiguracoesBoletim";
    const { periodoSelecionado } = useAuth();

    const [avaliacoes, setAvaliacoes] = useState<any>([]);
    const [camposHabilitados, setCamposHabilitados] = useState<{ [key: string]: boolean }>({});
    const [editarDesabilitado, setEditarDesabilitado] = useState<boolean>();
    const [configFormulasDialog, setConfigFormulasDialog] = useState<boolean>(false);
    const [formula, setFormula] = useState<any>();
    const [nomeFormula, setNomeFormula] = useState<any>();
    const [valorOriginal, setValorOriginal] = useState({});

    const [formulaVariavel1, setFormulaVariavel1] = useState('');
    const [formulaVariavel2, setFormulaVariavel2] = useState('');

    const camposDeFormulas = [{ name: 'FormulaAprovacao', label: 'Aprovação' },
    { name: 'FormulaMediaAvaliacao', label: 'Média da Avaliação' },
    { name: 'FormulaMinimoNaoReprovar', label: 'Mínimo para não reprovar' },
    { name: 'FormulaMinimoRecuperacao', label: 'Mínimo para recuperação' },
    { name: 'FormulaPrecisaDe', label: "'Precisa de' para a próxima avaliação" },
    { name: 'FormulaTotalPontos', label: 'Total de Pontos' },
    { name: 'FormulaVariavel1', label: 'Variável de Apoio 1' },
    { name: 'FormulaVariavel2', label: 'Variável de Apoio 2' }]

    const methods = useForm({});
    const { handleSubmit, control, formState: { errors }, watch, setValue, getValues, } = methods;

    const watchAvaliacoes = watch('AvaliacoesId');

    const load = async () => {
        const avaliacoes = await api.get('/boletimAvaliacoes', {
            params: {
                EmpresaId: periodoSelecionado?.EmpresaId,
                Ano: periodoSelecionado?.Ano,
                Sequencial: periodoSelecionado?.Sequencial,
            }
        });
        setAvaliacoes(avaliacoes.data)
        setEditarDesabilitado(true)
    };

    useEffect(() => {
        load();
    }, []);


    const handleEdit = (field: string) => {
        const value = getValues(field);
        setValorOriginal(value)
        setCamposHabilitados((prev) => ({ ...prev, [field]: true }));
        setEditarDesabilitado(true)
    };

    const handleTeste = (field: string, nome: string) => {
        const formula = getValues(field)
        const apoio1 = getValues('FormulaVariavel1');
        const apoio2 = getValues('FormulaVariavel2');

        setFormula(formula);
        setNomeFormula(nome)
        setFormulaVariavel1(apoio1);
        setFormulaVariavel2(apoio2);
        setConfigFormulasDialog(true);
    };

    const handleCancel = (field: string) => {
        setValue(field, valorOriginal)
        setEditarDesabilitado(false)
        setCamposHabilitados((prev) => ({ ...prev, [field]: false }));
    }

    const handleSave = async (field: string, label: string) => {
        const value = getValues(field);

        const boletimFormulas = await api.get('/boletimFormulas', {
            params: {
                EmpresaId: periodoSelecionado?.EmpresaId,
                Ano: periodoSelecionado?.Ano,
                Sequencial: periodoSelecionado?.Sequencial,
                AvaliacoesId: watchAvaliacoes,
            }
        })

        setCamposHabilitados((prev) => ({ ...prev, [field]: false }));

        if (boletimFormulas.data.length > 0) {
            const updateBoletimFormulas = {
                EmpresaId: periodoSelecionado?.EmpresaId,
                Ano: periodoSelecionado?.Ano,
                Sequencial: periodoSelecionado?.Sequencial,
                AvaliacoesId: watchAvaliacoes,
                [field]: value
            }

            await api.put('/boletimFormulas', updateBoletimFormulas)
        } else {
            const createBoletimFormulas = {
                EmpresaId: periodoSelecionado?.EmpresaId,
                Ano: periodoSelecionado?.Ano,
                Sequencial: periodoSelecionado?.Sequencial,
                AvaliacoesId: watchAvaliacoes,
                [field]: value
            }

            await api.post('/boletimFormulas', createBoletimFormulas)
        }

        toast.showToast({ severity: 'success', summary: 'Sucesso', detail: `Fórmula "${label}" salvo com sucesso.` });
        setEditarDesabilitado(false)
    };

    const handleAvaliacoes = async (value: any) => {
        value ? setEditarDesabilitado(false) : setEditarDesabilitado(true);
        const boletimFormulas = await api.get('/boletimFormulas', {
            params: {
                EmpresaId: periodoSelecionado?.EmpresaId,
                Ano: periodoSelecionado?.Ano,
                Sequencial: periodoSelecionado?.Sequencial,
                AvaliacoesId: value,
            }
        });

        const dados = boletimFormulas.data?.[0] ?? {};

        camposDeFormulas.forEach(({ name }) => {
            setValue(name, dados?.[name] ?? '');
        });

        toast.showToast({ severity: 'info', summary: 'Informe', detail: `Consulta realizada com sucesso!` });
    };

    const hideDialog = () => {
        setConfigFormulasDialog(false);
    };

    return (
        <div className="grid crud-demo">
            <div className="col-12">
                <div className="card">
                    <div className="flex justify-content-center align-items-center p-2 border-round-top-md text-white" style={{ backgroundColor: "#0772B3" }}>
                        <h5 className="m-0 flex flex-1 align-items-center justify-content-center">
                            Configurações de Fórmulas de Secretaria
                        </h5>
                    </div>

                    <SCFieldset legend="Avaliação" className="mt-2" >
                        <div className="grid">
                            <div className="col-6">
                                <SCDropdown
                                    control={control}
                                    name="AvaliacoesId"
                                    options={avaliacoes}
                                    optionValue="AvaliacoesId"
                                    optionLabel="Descricao"
                                    onChange={(e) => handleAvaliacoes(e.target.value)}
                                    value={watchAvaliacoes}
                                />
                            </div>
                        </div>
                    </SCFieldset>

                    <SCFieldset legend="Fórmulas" className="mt-2" >
                        <div className="grid">
                            {camposDeFormulas.map(({ name, label }) => (
                                <div className="col-12 pt-2" key={name}>
                                    <div className="flex gap-2">
                                        <div className="flex-grow-1">
                                            <SCInputTextarea
                                                control={control}
                                                name={name}
                                                label={label}
                                                style={{ width: '100%' }}
                                                rows={4}
                                                disabled={!camposHabilitados[name]}
                                                onChange={(e) => {
                                                    const upperText = e.target.value.toUpperCase();
                                                    setValue(name, upperText);
                                                }}
                                            />
                                        </div>
                                        <div className="flex flex-column gap-2 pt-4" style={{ minWidth: '85px' }}>
                                            <SCButton
                                                icon="pi pi-pencil"
                                                className="p-button-info"
                                                style={{ width: '100%' }}
                                                onClick={() => handleEdit(name)}
                                                disabled={editarDesabilitado}
                                                label="Editar"
                                            />
                                            <SCButton
                                                icon="pi pi-cog"
                                                className="p-button-warning"
                                                style={{ width: '100%' }}
                                                onClick={() => handleTeste(name, label)}
                                                disabled={editarDesabilitado}
                                                label="Testar"
                                            />
                                        </div>
                                        <div className="flex flex-column gap-2 pt-4" style={{ minWidth: '85px' }}>
                                            <SCButton
                                                icon="pi pi-save"
                                                className="p-button-success"
                                                style={{ width: '100%' }}
                                                onClick={() => handleSave(name, label)}
                                                disabled={!camposHabilitados[name]}
                                                label="Gravar"
                                            />
                                            <SCButton
                                                icon="pi pi-times"
                                                className="p-button-danger"
                                                style={{ width: '100%' }}
                                                onClick={() => handleCancel(name)}
                                                disabled={!camposHabilitados[name]}
                                                label="Cancelar"
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </SCFieldset>

                    <SCDialog maximized={!util.isDesktop()} visible={configFormulasDialog} style={{ width: util.isDesktop() ? '80%' : '100%' }} closable={!util.isDesktop()}
                        header={`Testando a Fórmula: ${nomeFormula}`}
                        modal className="p-fluid" onHide={hideDialog}>
                        <ConfiguracaoFormulasForm
                            setConfigFormulasDialog={setConfigFormulasDialog}
                            formula={formula}
                            nome={nomeFormula}
                            reload={load}
                            FormulaVariavel1={formulaVariavel1}
                            FormulaVariavel2={formulaVariavel2}
                        />
                    </SCDialog>
                </div>
            </div>
        </div>
    );
};

export default ConfiguracoesFormulas;
